module.exports = __webpack_public_path__ + "static/2front-web-3-d1f761030558a517d279863a975ba473.png";